import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { getAccountMemberSessions, type MemberSessionsResponse } from '../api';
import type { Account } from '../model';

import { useAccountQuery } from './useAccountQuery';

export function useMemberSessions(account: Account | null | undefined) {
  return useAccountQuery<MemberSessionsResponse | null, RequestError>(
    account
      ? (queryKeys.accounts.memberSessions(account._id) as readonly unknown[])
      : ['accounts', 'member-sessions', null],
    ({ signal }) => (account ? observableToPromise(getAccountMemberSessions(account), signal) : Promise.resolve(null)),
    account,
  );
}
